import React, { forwardRef, useCallback } from 'react'
import { HStack, Radio, RadioGroup } from '@chakra-ui/react'

export const RadioGroupBoolean = forwardRef(
  (
    { value, onChange, isLoading, isInvalid, isRequired, isReadOnly, isDisabled, ...props },
    ref
  ) => {
    const handleChange = useCallback(value => onChange?.(value === 'true'), [onChange])
    return (
      <RadioGroup {...props} value={`${value}`} onChange={handleChange} ref={ref}>
        <HStack>
          <Radio
            value='true'
            isInvalid={isInvalid}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            isDisabled={isLoading || isDisabled}>
            Sim
          </Radio>
          <Radio
            value='false'
            isInvalid={isInvalid}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            isDisabled={isLoading || isDisabled}>
            Não
          </Radio>
        </HStack>
      </RadioGroup>
    )
  }
)

export default RadioGroupBoolean
